import { useState } from 'react'
import {
  Box,
  Button,
  Image,
  Skeleton,
  Stack,
  Text
} from '@chakra-ui/react'
import { postTypeStatus } from 'utils/helpers'
import { COLORS } from 'utils/styles'
import { SUCCEEDED } from 'utils/constants'

import { TextAnimation } from 'components/UserSection/ProfileBlog/BlogList/TextAnimation'
import { CreateComment } from './CreateComment'
import { CommentsList } from './CommentsList'

export const Comments = ({
  eventComments,
  eventCommentTree,
  eventData,
  getEventCommentsStatus,
  GoToMarker,
  stickyHeader
}) => {
  const [editCommentData, setEditCommentData] = useState({})
  const [loadedProfileImage, setLoadedProfileImage] = useState(false)

  return (
    <Stack
      key={eventData?.id}
      minHeight="100%"
      height="auto"
      background={COLORS.darkGray}
    >
      <Stack
        position="sticky"
        top="48px"
        zIndex={260}
        background={COLORS.white}
        padding={eventCommentTree.length > 1 ? '0 5px 10px 5px' : '0 0 8px 0'}
        boxShadow="0 4px 10px rgba(0, 0, 0, 0.2)"
        _hover={{
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)'
        }}
      >
        {
          eventCommentTree.length > 1
            ? (
              <>
                <Stack
                  display="inline"
                  position="relative"
                >
                  <Skeleton
                    isLoaded={loadedProfileImage}
                    fadeDuration={1}
                    boxSize="55px"
                    position="relative"
                    objectFit="cover"
                    borderRadius="full"
                    display="inline-flex"
                    verticalAlign="bottom"
                    sx={{
                      '@media (max-width: 473px)': {
                        boxSize: '50px'
                      }
                    }}
                  >
                    <Image
                      src={eventCommentTree.at(-1)?.profile_picture}
                      borderRadius="full"
                      alt="User Image"
                      cursor="pointer"
                      onClick={() => GoToMarker(eventCommentTree.at(-1))}
                      onLoad={() => setLoadedProfileImage(true)}
                    />
                  </Skeleton>
                  <Text
                    display="inline-flex"
                    fontSize="16px"
                    lineHeight="28px"
                    wordBreak="break-word"
                    margin="10px 0 0 7.5px !important"
                    sx={{
                      '@media (max-width: 473px)': {
                        lineHeight: '25px'
                      }
                    }}
                  >
                    <Box display="contents">
                      { eventCommentTree.at(-1)?.full_name }
                    </Box>
                    <br />
                    <Box
                      display="contents"
                      letterSpacing="-1px"
                    >
                      {
                        postTypeStatus({
                          item: eventCommentTree.at(-1),
                          noLabel: true
                        })
                      }
                    </Box>
                  </Text>
                </Stack>

                <Stack
                  display="flex"
                  justifyContent="center"
                  direction="row"
                >
                  <Button
                    as="div"
                    background={COLORS.lightGoldGradientLeftToRight}
                    fontSize="19px"
                    padding="2px 0"
                    width="100%"
                    borderRadius="5px"
                    align="center"
                    letterSpacing=".15px"
                    fontWeight="400"
                    position="relative"
                    _hover={{
                      background: ''
                    }}
                    _active={{
                      background: ''
                    }}
                  >
                    <TextAnimation
                      item={eventCommentTree?.at(-1)}
                      blogParent={eventCommentTree}
                      place="event"
                    />
                  </Button>
                </Stack>
              </>
            ) : stickyHeader()
        }
      </Stack>

      <Stack
        padding="10px 5px 10px 5px"
        marginTop="-7px"
      >
        {
          getEventCommentsStatus === SUCCEEDED || eventComments?.length
            ? (
              <CreateComment
                editCommentData={editCommentData}
                setEditCommentData={setEditCommentData}
              />
            ) : ''
        }
        <CommentsList
          GoToMarker={GoToMarker}
          setEditCommentData={setEditCommentData}
        />
      </Stack>
    </Stack>
  )
}
